<template>
  <Transition name="fade">
    <div
      v-if="notifications.length"
      class="notifications"
      :class="{ 'super-admin': isSuperAdmin || actingAs }"
    >
      <Notification
        v-for="(notification, index) in notifications"
        :key="`notification-${index}`"
        :notification="notification"
      />
    </div>
  </Transition>
</template>

<script type="text/babel">
import Notification from './Notification.vue'

export default {
  name: 'Notifications',
  components: {
    Notification,
  },
  props: {
    isSuperAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    actingAs: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    notifications() {
      return this.$store.state.base.notifications
    },
  },
}
</script>
